<template>
  <a v-if="href" :href="href" download>
    <slot />
  </a>
  <span v-else class="is-disabled">
    <slot />
    <a-label path="download.link.notActive"></a-label>
    <a-label path="download.notSelected"></a-label>
  </span>
</template>

<script>
export default {
  inject: ['formContext'],
  props: {
    targetName: {
      type: String,
    },
    url: {
      type: String,
    },
  },
  computed: {
    href() {
      const url = this.url || this.formContext.fields[this.targetName];
      return url ? url : false;
    },
  },
};
</script>
